export interface Input {
  content: Marko.Body;
}

<let/isVisible=false>

<div.${
  (styles as unknown as Record<string, string>).observed
}/placeholder hidden=isVisible/>

<if=isVisible>
  <${input.content}/>
</if>

<lifecycle<{ observer?: IntersectionObserver }>
  onMount() {
    const el = placeholder();

    this.observer = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.intersectionRatio > 0)) {
        this.observer?.unobserve(el);
        isVisible = true;
      }
    });
    this.observer.observe(el);
  }
  onDestroy() {
    this.observer?.disconnect();
  }
>

<style.scss/styles>
  .observed {
    block-size: 0;
    inline-size: 1px;
  }
</style>
